import React from "react";

export default class AnonTemplate extends React.Component {
    render() {
        return (
            <div id={'AnonTemplate'}>
                <span className={"gradientBg"}></span>
                <main>
                    <div className="top-logo no-select">
                        <img
                            src={"/logo-full192.png"}
                            alt={"ElecTrek"}
                            className={"shadow"}
                        />
                    </div>
                    {this.props.children}
                </main>
            </div>
        );
    }
}
